/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 */
import React, { lazy, Suspense, useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../Banner/Banner.css";
import RigVedQuotes from "../RigvedQuotes";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu";
const Form = lazy(() => import("../../components/SignUpForm/SignUpForm"));

export default function Body({ links }) {
  const imgCDNURL = process.env.REACT_APP_TXAUSTINEPOST_CDN_URL;

  return (
    <>
      <div className="banner">
        <Container className="bannercontainer">
          <Row>
          <div className="userway-div-mobile">
        <UserWayAccessibilityMenu color="white" width={40} height={40} />
        </div>
            <Col sm={12} md={12} xl={7} lg={7} xxl={7}>
              <div className="bannertextstag">
                <div className="titlestag">
                  <p className="mastertitle">Finance On Demand <br></br> Ai Brokers Are the Best</p>
                </div>
                <div className="Atlantatext-div">
                  <p className="Atlantatext">
                    <span className="chartingimg">Charting the Future of Mortgages: </span><br></br>
                    Chicago Mortgage Originators Expo Recap
                  </p>
                </div>
              </div>
              <div>
                <p className="flueltext">
                  Relive the Chicago Mortgage Expo, where innovation collided
                  with opportunity and the mortgage landscape witnessed a
                  groundbreaking evolution. Experience the captivating moments
                  that defined this extraordinary event, setting new benchmarks
                  for the mortgage industry.
                </p>
              </div>
            </Col>

            <Col sm={12} md={12} xl={5} lg={5} xxl={5}>
              <div className="formsection formdesk">
                <Suspense fallback={<div />}>
                  <Form />
                </Suspense>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
